import { CrudStoreItemOnboarding } from 'legacy/lut/classes/models/onboarding/CrudStoreItemOnboarding'
import { INotificationTemplate } from 'legacy/lut/classes/models/onboarding/INotificationTemplate'
import {
  ENotificationTemplate,
  RequestTypes,
} from 'legacy/lut/classes/models/onboarding/Onboarding'
import OnboardingStoreService from 'legacy/lut/classes/services/OnboardingStoreService'
import { appGetState } from 'legacy/lut/store'
import { useMemo, useState } from 'react'

import { Button, IButtonProps } from 'core-components/library/button'
import { ModalDialog } from 'core-components/library/modalDialog'
import { VisualAudience } from 'core/components/shared/ui/VisualAudience'
import { CrudStore } from 'core/types/crudStore'

import { RejectRequestDialog } from './RejectRequestDialog'

interface IProps {
  requestId: number
  reqType: string
  currentComment?: string
  buttonText?: string
  doBeforeSave?: () => void
  doAfterSave?: () => void
  margin?: IButtonProps['margin']
}

const getNotificationTemplateUUID = (requestType: RequestTypes | string): string => {
  switch (requestType) {
    case RequestTypes.Contract:
      return ENotificationTemplate.RejectContractRequest
    case RequestTypes.Exception:
    case RequestTypes.RetailException:
      return ENotificationTemplate.RejectExceptionRequest
    default:
      return ENotificationTemplate.RejectRequest
  }
}

export const RejectRequest = ({
  requestId,
  currentComment,
  reqType,
  buttonText = 'Reject Request',
  doBeforeSave,
  doAfterSave,
  margin,
}: IProps) => {
  const [showDialog, setShowDialog] = useState(false)
  const notificationSource = CrudStore.get(
    CrudStoreItemOnboarding.UniqNotificationTemplates,
    'Reject Request'
  )

  const roles = useMemo(() => {
    return appGetState().user.roleIds.filter((role: string) => role !== 'Exception Read Only')
  }, [])

  const getNotifTemplate = () => {
    return notificationSource.getById({
      id: getNotificationTemplateUUID(reqType),
      keyField: 'UUID',
    })
  }

  const onSave = async (comment: string) => {
    doBeforeSave && doBeforeSave()

    const response = await getNotifTemplate()
    const notification = response || ({} as INotificationTemplate)
    const resultComment = currentComment ? currentComment + `; ${comment}` : comment
    await OnboardingStoreService.rejectRequest(requestId, resultComment)
    await OnboardingStoreService.sendRejectNotification(
      +requestId,
      notification.UUID,
      notification['MailTo'],
      notification['CC'] || '',
      notification['MailFrom'] || ''
    )

    doAfterSave && doAfterSave()

    setShowDialog(false)
  }

  const openDialog = () => {
    setShowDialog(true)
  }

  return (
    <div>
      <VisualAudience<IButtonProps>
        write={roles}
        component={Button}
        color="danger"
        onClick={() => openDialog()}
        margin={margin}
      >
        {buttonText}
      </VisualAudience>
      <ModalDialog
        size="sm"
        content={RejectRequestDialog}
        contentProps={{
          onSave: (value: string) => onSave(value),
        }}
        isContainerRestricted={false}
        show={showDialog}
        onClose={() => setShowDialog(false)}
      />
    </div>
  )
}
